'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.dcos.instance.details', [
  require('./details.controller.js').name,
]);



// WEBPACK FOOTER //
// ./app/scripts/modules/dcos/instance/details/details.dcos.module.js